import { MdHighlightOff } from 'react-icons/md'

import styles from './conflict.module.scss'

interface ErrorHandlerProps {
  error: any
}

const containerClassName = 'flex flex-row bg-[#d044370d] border-1 border-solid border-[#d04437] rounded-md m-4 p-4'

export const ErrorHandler = (props: ErrorHandlerProps): JSX.Element => {
  const title = props.error?.title ?? ''
  const msg = props.error?.message
  return (
    <div className={containerClassName}>
      <div className={styles.block}>
        <MdHighlightOff size='1.5rem' />
      </div>
      <div className={styles.info}>
        {title && <div className={styles.title}>{title}</div>}
        <div className={styles.subTitle}>
          <p>
            {msg}
          </p>
        </div>
      </div>
    </div>
  )
}
